export const getTruncatedAccountNumber = (
  accountNumber: string,
  sign: string,
  end: number,
) => {
  const lastFourDigits = accountNumber?.slice(-end);
  const maskedPart = accountNumber?.slice(0, -end)?.replace(/\d/g, sign);
  return maskedPart + lastFourDigits;
};
